import { SampleRequestListUrlSortField } from "../../urls";

export const DEFAULT_SORT_KEY = SampleRequestListUrlSortField.date;

export function getSortQueryVariables(
  params: URLSearchParams | any,
): { direction: "ASC" | "DESC"; field: string } | undefined {
  if (!params.sort) {
    return;
  }

  const direction = params.sort.startsWith("-") ? ("DESC" as const) : ("ASC" as const);
  const field = params.sort.replace("-", "") as SampleRequestListUrlSortField;

  switch (field) {
    case SampleRequestListUrlSortField.date:
      return { direction, field: "CREATED_AT" };
    case SampleRequestListUrlSortField.customer:
      return { direction, field: "CUSTOMER" };
    default:
      return { direction, field: "CREATED_AT" };
  }
}